import { h } from 'preact'

import './index.sass'

export default function Spinner({ className = '', ...props }){
  return <span {...props} className={`Spinner ${className}`} />
}
